import { useEffect } from "react";
import { FTLShortcutUtils } from "../../util";
export default (key, callback) => {
    useEffect(() => {
        const handler = (e) => {
            if (e.code === FTLShortcutUtils.getKeyCode(key) &&
                !(e.target instanceof HTMLInputElement))
                callback(e);
        };
        document.addEventListener("keyup", handler);
        return () => {
            document.removeEventListener("keyup", handler);
        };
    }, [callback]);
};
//# sourceMappingURL=useShortcut.js.map